import { ActionIcon, type ActionIconProps } from '@mantine/core';
import type { EmotionSx } from '@mantine/emotion';
import { type ComponentPropsWithoutRef, forwardRef } from 'react';

export const IconButton = forwardRef(
  (
    {
      children,
      sx,
      component,
      ...props
    }: ActionIconProps & {
      component?: any;
      href?: string;
      target?: string;
      to?: string;
      sx?: EmotionSx;
    } & ComponentPropsWithoutRef<'button'>,
    ref
  ) => {
    return (
      <ActionIcon
        ref={ref}
        variant="transparent"
        component={component}
        sx={(theme, u) =>
          Object.assign(
            {
              borderRadius: '20%' as any,
              ':hover': {
                backgroundColor: '#00000000',
              },
            },
            typeof sx === 'function' ? sx(theme, u) : sx
          )
        }
        {...props}
      >
        {children}
      </ActionIcon>
    );
  }
);

IconButton.displayName = 'IconButton';
